import React from 'react';
import InputField, {InputFieldProps} from "./InputField";

// Component ----

export type ColourFieldProps = Omit<InputFieldProps, 'type'>

function ColourField(props: ColourFieldProps) {
    return (
      <InputField
        type="color"
        className="appearance-none w-full h-14 -ml-0.5 bg-transparent border-0 cursor-pointer"
        {...props}
      />
    )
}

export default ColourField;